import { render, staticRenderFns } from "./FormSequenLivros.vue?vue&type=template&id=45b32964&scoped=true&"
import script from "./FormSequenLivros.vue?vue&type=script&lang=js&"
export * from "./FormSequenLivros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b32964",
  null
  
)

export default component.exports